<template>
  <el-container>
    <el-header height="80px">
      <div class="align-center-main center-bar">
        <nav>
          <router-link to="/" class="logo">
            <img src="../../static/image/logo.png">
          </router-link>
          <div class="logoword">天安商城</div>
          <router-link :to="{ path: '/shoppingMall/mall', query: { categoryId: shouye.length ? 2000 : '' } }">首页</router-link>
          <router-link v-for="(item, index) in categoryList" :key="index" :to="{ path: '/shoppingMall/category', query: { categoryId: item.id } }" class="textOver" exact>{{item.name}}
            <ul class="clearfix boxShadow" @click.stop.prevent="1">
              <li v-for="(v, i) in item.children" :key="i" @click.stop.prevent="goCategory(v.id)" class="textOver">{{v.name}}</li>
            </ul>
          </router-link>
        </nav>
        <div class="login" v-if='!token'>
          <div class="gongzhonghao">
            公众号
            <img src="@/assets/homePage/qrcode.png">
          </div>
          <router-link to="/navigator/auth/regist">注册</router-link>
          <router-link to="/navigator/auth/login">登录</router-link>
        </div>
        <!-- 个人中心 -->
        <el-dropdown class='dropdown' v-else @command="handleCommand">
          <span class="el-dropdown-link" @click.stop='toPersonal'>
            {{ user.userNick || user.userMobile }} - 个人中心<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="item"
                              v-for="item in user.bindParkInfo"
                              :key="item.parkId">
              园区后台({{ item.parkNameAcronym }})
            </el-dropdown-item>
            <el-dropdown-item
              v-if='user.bindCorpInfo && user.bindCorpInfo.parkId'
              command="corp">
              企业后台
            </el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <el-main>
      <!-- 搜索 -->
      <div class="align-center-main">
        <div class="search" :style="{display: showSearch?'block':'none'}">
          <div class="clearfix">
            <input type="text" class="searchipt" v-model="searchThings">
            <div class="searchbtn" @click="goSearch" >搜 索</div>
          </div>
        </div>
      </div>
      <!-- 路由窗口 -->
      <router-view @set-search-bar="setSearchBar"></router-view>
    </el-main>
    <Footer></Footer>
      <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>

  </el-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import taUrl from '@/static/backstageUrl';
import Footer from '@/components/Footer';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return {
      submitSuccessFlag: false,
      tipsMsg: '登陆状态已失效，请重新登陆',
      navList: [],
      categoryList: [],
      shouye: [],
      searchThings: '',
      showSearch: true,
    }
  },
  methods: {
    ...mapMutations(['change_token', 'change_user']),
    handleCommand(command) {
      let token = encodeURIComponent(this.token);
      switch(command) {
        case 'corp':
          window.open(`${taUrl.corpUrl}/#/usertoken?token=${token}&park_id=${this.user.bindCorpInfo.parkId}&corp_id=${this.user.bindCorpInfo.corpId}`);
          break;
        case 'logout':
          this.logoutUser();
          break;
        default:
        // 企业后台
          window.open(`${taUrl.parkUrl}/#/user?token=${token}&park_id=${command.parkId}`);
          break;
      }
    },
    toPersonal() {
      this.$router.push({ path: '/navigator/personal/info', });
    },
    getUserInfo() {  // 获取用户详情
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        }
      });
    },
    getNavList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/category/tree`, { parkId: this.currentParkId }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        this.setSearchBar(true)
        if (res.resCode === '10000') {
          res.resData.sort((a,b) => (a.sort - b.sort))
          this.navList = JSON.parse(JSON.stringify(res.resData))
          let data = JSON.parse(JSON.stringify(res.resData))
          this.shouye = data.splice(0,1)
          this.categoryList = data
          if (this.$route.name !== 'productDetalis') {
            this.$router.push({ path: '/shoppingMall/mall', query: { categoryId: this.shouye[0].id } });
          }
        }
      });
    },
    logoutUser() {
      this.$http.post(`${this.URL_PREFIX}/app/user/logout`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token('');
          this.change_user('');
          this.$router.push({ path: '/navigator/auth/login' });
        }
      });
    },
    goCategory(id){
      this.$router.push({ path: '/shoppingMall/secondCategory', query: { categoryId: id } })
    },
    goSearch(){
      this.$router.push({ path: '/shoppingMall/search', query: { searchThings: this.searchThings, page:1} });
    },
    setSearchBar(show){
      this.showSearch = show
    }
  },
  components: {
    Footer
  },
  computed: {
    ...mapGetters(['token', 'user', 'currentParkId', ]),
  },
  created() {
    if (this.token) {
      this.getUserInfo();
    }
    this.searchThings = '';
    this.getNavList();
  },
}
</script>

<style scoped lang="scss">
  @import "~@scss";
  .el-header{
    background-color: #333;
    .center-bar{
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logoword{
        font-size: 24px;
        color: #fff;
        margin-right: 20px;
      }

      a{
        ul {
          display: none;
          top: 80px;
          position: absolute;
          z-index: 666;
          width: 1200px;
          min-height: 68px;
          left: 0;
          background-color: #fff;
          li {
            float: left;
            width: 280px;
            height: 68px;
            padding: 0 10px;
            line-height: 68px;
            color: #000;
            text-align: center;
            &:hover{
              background-color: #ccc;
            }
          }
        }
        &:hover{
          ul{
            display: block;
          }
        }
      }

      nav{
        height: 80px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        a.logo img{
          width: 253px;
        }
        a:not(.logo){
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #fff;
          height: 100%;
          box-sizing: border-box;
          border-bottom: 2px solid transparent;
          padding: 30px;
          &:hover, &.router-link-active{
            border-color: $color-red;
          }
        }
      }

      .login{
        display: flex;
        height: 100%;
        align-items: center;
        & > a, .gongzhonghao{
          font-size: 16px;
          color: #fff;
          line-height: 1;
          &:hover{
            color: #999;
          }
        }
        .gongzhonghao{
          cursor: pointer;
          margin-right: 20px;
          display: flex;
          align-items: center;
          height: 100%;
          position: relative;
          img{
            display: none;
            margin-left: -45px;
            position: absolute;
            top: 60px;
            z-index: 999999;
          }
          &:hover img{
            display: block;
          }
        }
        & > a{
          padding: 0 10px;
          border-right: 1px solid #fff;

          &:last-child{
            border-right: none;
          }
        }
      }

      .dropdown{
        height: 100%;
        cursor: pointer;
        color: #FFFFFF;
        .el-dropdown-link{
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .el-main {
    background-color: #f6f6f6;
    color: #333;
    padding: 30px 0 0 0;
  }

  .el-container {
    min-width: 1200px;
    min-height: 100%;
  }

.el-carousel-item {
  height: 500px;
}

  .center-bar{
    position: relative;
    .dropdown{
      position: absolute;
      right: 0;
      cursor: pointer;
      color: #FFFFFF;
      .el-dropdown-link{
        float: left;
        height: 100%;
      }
    }
  }

.parkDropdown {
  margin-left: 20px;
  padding: 0 20px;
  cursor: pointer;
  p {
    color: #fff;
    font-size: 12px;
  }
}
.el-dropdown-menu__item {
  height: 36px;
  display: flex;
  align-items: center;
}
.iconImg {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: middle;
}

.submit-success {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

//搜索
.search{
  width: 1200px;
  // height: 182px;
  box-sizing: border-box;
  // background-color: #fff;
  padding-bottom: 30px;
  // display: block;
  margin: 0 auto;
  .searchClassbox{
    float: left;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .searchipt{
    width: 1032px;
    height: 26px;
    padding: 5px 15px;
    border: 1px solid #d9262c;
    outline: none;
    font-size: 16px;
    float: left;
  }
  .searchbtn{
    width: 136px;
    height: 38px;
    background-color: #d9262c;
    color: #fff;
    float: left;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/ShoppingMall.vue